<button type="button" :title="title" :class="btnClass" @click="submitDelete" :disabled="disabled"><slot/></button>
